import(/* webpackMode: "eager" */ "/app/app/chatbot/page.tsx");
